import React from 'react';
import PropTypes from 'prop-types';
import Container from './Container';
import { Divider } from '@material-ui/core';
import { balanceSelector } from '../../../../../../helpers/BankHelper';
import { useExchangeMobileStyles } from './styles';

const ExchangeMobile = ({ ...props }) => {
  const { rows, instructions, balance } = props;
  const classes = useExchangeMobileStyles();
  return (
    <>
      {rows.map((row, index) => (
        <React.Fragment key={index}>
          {index === 0 && <Divider className={classes.divider} />}
          <Container
            row={row}
            instructions={instructions}
            balance={balanceSelector(balance, row.productFolio)}
          />
          <Divider className={classes.divider} />
        </React.Fragment>
      ))}
    </>
  );
};

ExchangeMobile.propTypes = {
  rows: PropTypes.array,
  instructions: PropTypes.array,
  balance: PropTypes.array,
};

export default ExchangeMobile;
